// 默认全局实例
let defaultClient = null;
export function getDefaultClient() {
    if (!defaultClient) {
        throw new Error('Default client not initialized. Call initDefaultClient() first.');
    }
    return defaultClient;
}
export function initDefaultClient(client) {
    defaultClient = client;
}
